import styled from 'styled-components';

export const ReviewCardsStyles = styled.div<{
  color?: 'dark-violet' | 'domination';
}>`
  body.dark & {
    --card-box-shadow: none;
    --card-content-background: linear-gradient(
      180deg,
      #3f3350 0%,
      #30202e 100%
    );
    --card-box-border-color: linear-gradient(180deg, #4a18aa 0%, #14111e 100%);

    ${({ color }) =>
      color === 'dark-violet' &&
      `
        --card-box-shadow: none;
        --card-content-background: #765279;
        --card-box-border-color: #765279;
      `}

    ${({ color }) =>
      color === 'domination' &&
      `
        --card-box-shadow: none;
        --card-content-background: rgba(255, 255, 255, 0.1);
        --card-box-border-color: transparent;
      `}
  }

  margin-top: 20px;

  --card-content-background: #fff;
  --card-box-shadow: 0px 187px 52px 0px rgba(0, 0, 0, 0),
    0px 120px 48px 0px rgba(0, 0, 0, 0.01),
    0px 67px 40px 0px rgba(0, 0, 0, 0.02), 0px 30px 30px 0px rgba(0, 0, 0, 0.04),
    0px 7px 16px 0px rgba(0, 0, 0, 0.05);
  --card-box-border-color: #f2f2f7;

  ${({ color }) =>
    color === 'domination' &&
    `
      --card-content-background: ку;
      --card-box-border-color: #d1b7ff;
    `}

  .review-cards-swiper {
    width: 100%;
    overflow: visible;
  }

  .review-card {
    border-radius: 24px;
    max-width: 300px;
    width: 100%;
    box-shadow: var(--card-box-shadow);
    min-height: 204px;

    &-content {
      padding: 20px 12px;
      background: var(--card-content-background);
      position: relative;
      border-radius: 23px;
      min-height: 204px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      &::after {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: -1;
        content: '';
        display: block;
        width: calc(100% + 2px);
        height: calc(100% + 2px);
        background: var(--card-box-border-color);
        border-radius: 24px;
      }
    }

    @media screen and (min-width: 576px) {
      max-width: 400px;
    }

    .stars {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 6px;
    }

    .text,
    .author {
      margin: 12px 0 0;
      text-align: center;
    }
  }
`;
